import { createAsyncThunk } from '@reduxjs/toolkit';

import { AuthorizedIssuer } from '../../../../common/types/Entities';
import { handleListFetch } from '../apiHelpers';

import { APIAuthorizedIssuerDelete, APIAuthorizedIssuerGetList, APIAuthorizedIssuerPost } from './AuthorizedIssuers.api';

export const fetchAuthorizedIssuers = createAsyncThunk('authorizedIssuers/fetchAuthorizedIssuers', async (item: { tenantId: string, signal?: AbortSignal }) => {
    const response = await APIAuthorizedIssuerGetList(item);
    return formatAuthorizedIssuers(response.data);
});

export const postAuthorizedIssuer = createAsyncThunk('authorizedIssuers/postAuthorizedIssuer', async (item: { tenantId: string, identityProviderId: string, audience: string }) => {
    const response = await APIAuthorizedIssuerPost(item);
    const rows = formatAuthorizedIssuers(await handleListFetch(APIAuthorizedIssuerGetList( { tenantId: item.tenantId } )));
    return {
        response,
        rows
    };
});

const formatAuthorizedIssuers = (rows: AuthorizedIssuer[]) => {
    return rows.map(( item ) => ({
        'id': `${item.tenantId}.${item.identityproviderId}.${item.audience}`,
        'identityProviderId': item.identityproviderId,
        ...item
    }));
};

export const deleteAuthorizedIssuer = createAsyncThunk(
    'authorizedIssuers/deleteAuthorizedIssuer',
    async (item: { tenantId: string, authorizedIssuerId: string, audience: string }) => {
        const response = await APIAuthorizedIssuerDelete(item);
        const rows = formatAuthorizedIssuers(await handleListFetch(APIAuthorizedIssuerGetList({ tenantId: item.tenantId })));
        return {
            response,
            rows
        };
    }
);
